import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import OperationLog from '@/components/OperationLog/OperationLog'
import SourceMain from '@/components/Sources/SourceMain'
import NewsMain from '@/components/News/NewsMain'
import NewsEdition from '@/components/NewsEdition'
import ThemeWords from '@/components/ThemeWords'
import store from '../store'

Vue.use(Router)

const vueRouter = new Router({
  routes: [
    {
      path: '/',
      redirect: {
        path: '/login'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/NewsEdition',
      name: 'NewsEdition',
      component: NewsEdition
    },
    {
      path: '/Sources',
      name: 'SourceMain',
      component: SourceMain
    },
    {
      path: '/Logs',
      name: 'OperationLog',
      component: OperationLog
    },
    {
      path: '/News',
      name: 'NewsMain',
      component: NewsMain
    },
    {
      path: '/ThemeWords',
      name: 'ThemeWords',
      component: ThemeWords
    }
  ]
})

vueRouter.beforeEach((to, from, next) => {
  if (to.name != 'Login' && !store.getters['auth/isLoggedIn']) {
    return next('/login');
  }

  if (to.name == 'Login' && store.getters['auth/isLoggedIn']) {

    return next('/Home')
  }

  if (to.name == 'Login' && !store.getters['auth/isLoggedIn']) {

    return next();
  }

  return next();
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js